export class CaptionsService {
  private recognition: any = null;
  private _isActive: boolean = false;
  private isSupported: boolean = false;

  public onTranscript?: (text: string, isFinal: boolean) => void;

  constructor() {
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (SpeechRecognition) {
      this.isSupported = true;
      try {
        this.recognition = new SpeechRecognition();
        this.recognition.continuous = true;
        this.recognition.interimResults = true;
        this.recognition.lang = 'en-US';

        this.recognition.onresult = (event: any) => {
          let interimTranscript = '';
          let finalTranscript = '';

          for (let i = event.resultIndex; i < event.results.length; ++i) {
            if (event.results[i].isFinal) {
              finalTranscript += event.results[i][0].transcript;
            } else {
              interimTranscript += event.results[i][0].transcript;
            }
          }

          const text = finalTranscript || interimTranscript;
          if (text && this.onTranscript) {
            this.onTranscript(text.trim(), Boolean(finalTranscript));
          }
        };

        this.recognition.onerror = (event: any) => {
          console.warn('SpeechRecognition error:', event.error);
        };

        this.recognition.onend = () => {
          if (this._isActive) {
            try {
              this.recognition.start();
            } catch (_) {}
          }
        };
      } catch (err) {
        console.warn('SpeechRecognition setup error:', err);
      }
    }
  }

  public getIsSupported(): boolean {
    return this.isSupported;
  }

  public isActive(): boolean {
    return this._isActive;
  }

  public start(): boolean {
    if (this._isActive) return true;
    this._isActive = true;
    if (this.recognition) {
      try {
        this.recognition.start();
        return true;
      } catch (err) {
        console.warn('Could not start native SpeechRecognition:', err);
      }
    }
    return true;
  }

  public stop() {
    this._isActive = false;
    if (this.recognition) {
      try {
        this.recognition.stop();
      } catch (_) {}
    }
  }
}
